var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { faFilter, faTimes } from '@fortawesome/free-solid-svg-icons';
import './NxFilterInput.scss';
import NxFontAwesomeIcon from '../NxFontAwesomeIcon/NxFontAwesomeIcon';
import { propTypes } from './types';
var NxFilterInput = forwardRef(function NxFilterInput(props, ref) {
    var value = props.value, placeholder = props.placeholder, onChange = props.onChange, onClear = props.onClear, className = props.className, inputId = props.inputId, disabled = props.disabled, otherProps = __rest(props, ["value", "placeholder", "onChange", "onClear", "className", "inputId", "disabled"]), classes = classnames('nx-filter-input', className, {
        'nx-filter-input--disabled': disabled
    }), icon = value ? faTimes : faFilter;
    function inputOnChange(e) {
        if (onChange) {
            onChange(e.currentTarget.value);
        }
    }
    return (React.createElement("div", __assign({}, otherProps, { className: classes, ref: ref }),
        React.createElement("span", { className: "nx-filter-input__add-on", onClick: value && onClear || undefined },
            React.createElement(NxFontAwesomeIcon, { icon: icon })),
        React.createElement("input", { type: "text", autoComplete: "off", id: inputId || undefined, value: value, onChange: inputOnChange, placeholder: placeholder || undefined, className: "nx-filter-text-input", disabled: disabled || undefined })));
});
NxFilterInput.propTypes = propTypes;
export default NxFilterInput;
//# sourceMappingURL=NxFilterInput.js.map